
import useAuthIsAccountActivated from '../common/client/hooks/mysliveckyportal/useAuthIsAccountActivated';
import useAuthToken from '../common/client/hooks/mysliveckyportal/useAuthToken';

export default function useNavigationItems() {

    const token = useAuthToken();
    const activated = useAuthIsAccountActivated();

    let navigationItems = [];

    navigationItems.push({to: '/', page: 'home', title: 'Domů'});
    navigationItems.push({to: '/articles', page: 'articles', title: 'Články'});
    if (token && activated) {
        navigationItems.push({to: '/apps', page: 'apps', title: 'Aplikace'});
    }

    return navigationItems;
}
